<script setup>
    import { defineProps } from 'vue'
    import { useThemeStore } from '@/store/theme'
    import { getVideoIframeAttributes } from '@/mixins/global/globalMethods'
    import CustomButton from '@/components/reuseables/customButton.vue'

    const themeStore = useThemeStore()

    defineProps({
        data: Object,
    })

    const api = process.env.VUE_APP_API_URL

    function updateCookiebotConsent() {
        if (window.Cookiebot) {
            window.Cookiebot.submitCustomConsent(
                window.Cookiebot.consent.preferences,
                true,
                window.Cookiebot.consent.marketing,
                true
            )
        }
    }
</script>

<template>
    <div class="object-video">
        <v-row>
            <v-col
                cols="12"
                lg="4"
                order="1"
                :order-lg="!data?.invertLayout ? 1 : 2"
            >
                <div
                    v-if="data?.wysiwyg"
                    class="text"
                    v-html="data?.wysiwyg"
                />
            </v-col>
            <v-col
                cols="12"
                lg="8"
                order="2"
                :order-lg="!data?.invertLayout ? 2 : 1"
            >
                <div
                    v-if="data?.video"
                    class="video"
                >
                    <video
                        v-if="data?.video?.type === 'asset'"
                        controls
                        :poster="api + data?.video?.poster?.fullpath"
                        :style="{ aspectRatio: data?.aspectRatio }"
                    >
                        <source
                            :src="api + data?.video?.data?.fullpath"
                            type="video/mp4"
                        />
                    </video>
                    <template v-if="['youtube', 'vimeo'].includes(data?.video?.type)">
                        <div
                            v-if="themeStore.cookiebotConsent"
                            class="cookieconsent-optout-statistics"
                        >
                            <p>{{ themeStore.translate('video.cookies.notAccepted') }}</p>
                            <custom-button
                                class="theme-button"
                                @click="updateCookiebotConsent">
                                {{ themeStore.translate('video.cookies.accept') }}
                            </custom-button>
                        </div>
                        <iframe
                            v-bind="getVideoIframeAttributes(data?.video?.type, data?.video?.data?.id)"
                            :style="{ aspectRatio: data?.aspectRatio }"
                        />
                    </template>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<style scoped lang="scss">
    .object-video {
        .video {
            width: 100%;

            video,
            iframe {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
